<!-- 我的订单详情 -->
<template>
    <cc-container>
      <cc-header-nav title="订单详情"/>
      <cc-main>
        <div class="order-state">
          <cc-svg-icon size="23px" icon-class="order-status"/>
          <div class="ml14">
            <p class="status-word mb6 font1">{{order.order_cate_state_name}}</p>
            <span v-if="+order.order_state === 5" class="font2">请分销商尽快审核订单，需所有分订单审核完毕才同步</span>
          </div>
        </div>
        <div class="order-address">
          <cc-svg-icon size="23px" icon-class="address"/>
          <div class="ml14">
            <p class="mb6 font1 f14">{{order.contacter}}   {{order.mobile}}</p>
            <span class="font2">{{order.address}}</span>
          </div>
        </div>
        <div class="order-top">
          <span class="caption">商品列表</span>
          <span class="font2">{{order.goods_classify_sum}}种商品</span>
        </div>
        <div class="order-list" v-if="order.goods_list">
          <ul class="order-list-content" :key="index" v-for="(value,key,index) in  order.goods_list.sell_goods">
            <div class="activity-msg" v-if="index != 0 || !isNaN(key)"><p>{{value[0] && getPromotionInfo(value[0])}}</p></div>
            <li class="order-list-content-item" v-for="item in value" :key="item.goods_id">
              <div class="order-list-content-item-img">
                <img :src="item.thumb_img || $notImg" alt="">
              </div>
              <div class="order-list-content-item-info">
                <div>
                  <p class="font1">{{item.general_name}} {{item.norms}} {{item.produce_unit}}</p>
                  <div class="font2">数量：{{item.quantity}}</div>
                </div>
                <div class="order-list-content-item-info-bottom">
                  <div>
                      <span class="red">￥{{item.bid_price}}</span> （提成￥{{item.feedback_money}}）
                      <span v-if="item.type !== 1" class="goods-tag">{{goodsType[item.type + '']}}</span>
                        <span v-if="item.activity_introduc" class="goods-tag">活动</span>
                    </div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="order-list-content mt1" v-if="order.goods_list.gift_goods.length> 0">
            <li class="order-list-content-item" v-for="item in order.goods_list.gift_goods" :key="item.goods_id">
              <div class="order-list-content-item-img">
                <img :src="item.thumb_img || $notImg" alt="">
              </div>
              <div class="order-list-content-item-info">
                <div>
                  <p class="font1">{{item.general_name}} {{item.norms}} {{item.produce_unit}}</p>
                  <div class="font2">数量：{{item.quantity}}</div>
                </div>
                <div class="order-list-content-item-info-bottom">
                    <div class="font2">赠品</div>
                </div>
              </div>
            </li>
          </ul>
          <ul class="order-list-bottom">
            <li>
              <span class="font2">商品总额：</span>
              <span >￥{{order.sum_priced}}</span>
            </li>
            <li v-if="+order.discount_coupon_price">
              <span class="font2">全场促销：</span>
              <span>-￥{{order.discount_coupon_price}}</span>
            </li>
            <li v-if="+order.coupon_price">
              <span class="font2">优惠券：</span>
              <span>-￥{{order.coupon_price}}</span>
            </li>
            <li v-if="+order.use_coupon_price">
              <span class="font2">积分抵现：</span>
              <span>-￥{{order.use_coupon_price}}</span>
            </li>
            <li>
              <span class="font2">运费：</span>
              <span>￥{{order.express_price}}</span>
            </li>
            <li>
              <span class="font2">应付总额：</span>
              <span class="red">￥{{order.priced}}</span>
            </li>
            <li>
              <span class="font2">预估提成：</span>
              <span>￥{{order.order_feedback_money}}</span>
            </li>
          </ul>
        </div>
        <div class="order-info">
          <div class="order-info-top">
              订单信息
          </div>
          <ul class="order-info-content">
            <li>订单号：{{order.order_cate_number}}<span class="tag" v-if="+order.from_replace_member_id !== 0">代下单</span></li>
            <li>下单时间：{{order.post_date}}</li>
            <li>支付方式：{{order.payment_method_name}}</li>
            <li style="line-height:20px">备注：{{order.message}}</li>
          </ul>
        </div>
      </cc-main>
      <cc-footer>
        <div class="order-operation" v-if="showPopup">
          <span class="edit-price" @click="showPopup = false">取消</span>
          <span class="accept-order" @click="confirmEdit(1)">确定改价</span>
        </div>
        <div class="order-operation" v-else>
          <span v-if="~[0,5].indexOf(+order.order_state)" class="cancel" @click="showCancelOrder = true">弃单</span>
          <span v-if="+order.order_state === 5 && +order.payment_method !== 1" class="edit-price" @click="showPopup = true">改价</span>
          <span v-if="+order.order_state === 5" class="accept-order" @click="acceptOrder()">审核</span>
        </div>
      </cc-footer>
      <van-dialog
        v-model="showCancelOrder"
        title="弃单"
        class="van-dialog"
        show-cancel-button
        @confirm="confirmCancelOrder"
      >
      <div class="cancel-order-dialog">
        <p>弃单后订单将无法恢复，确定弃单</p>
        <input type="text" placeholder="请填写弃单理由">
      </div>
    </van-dialog>
      <edit-price-popup
        @loadData="loadData"
        :show.sync="showPopup"
        :orderNumber="order.order_cate_number"
        v-model="dealGoods"/>
    </cc-container>
</template>

<script>
import Vue from 'vue'
import { Dialog, Toast } from 'vant'
import EditPricePopup from './edit-price-popup'
import { loadOrderDetail, editOrderState, modifyPrice } from '~fetch/manage-center/myorder'
import { ResultCode } from '~const/ResultCode'
Vue.use(Dialog)
  .use(Toast)
Vue.use(Dialog)
export default {
  components: {
    EditPricePopup
  },

  data () {
    return {
      showPopup: false,
      isEditPrice: false,
      showCancelOrder: false,
      order: {},
      goodsType: {
        '1': '普通',
        '2': '特价',
        '3': '套餐价',
        '4': '满赠',
        '5': '赠品',
        '6': '积分兑换',
        '7': '积分抵现'
      }
    }
  },

  computed: {
    dealGoods () {
      const goodsArr = []
      if (this.order.goods_list) {
        let sellGoods = this.order.goods_list.sell_goods
        Object.keys(sellGoods).map(key => {
          sellGoods[key].map(item => {
            goodsArr.push(item)
          })
        })
      }
      return goodsArr
    },
    getPromotionInfo () {
      return (value) => {
        return `${value.promotion_type_name} ${value.promotion_title} (${value.promotion_info})`
      }
    }
  },

  created () {
    this.loadData()
  },

  methods: {
    async loadData () {
      const orderNumber = this.$route.query.id
      let { status, data } = await loadOrderDetail({ order_cate_number: orderNumber })
      if (status === ResultCode.SUCCESS) {
        this.order = data
      }
    },
    /**
     * @description 审核订单
     */
    acceptOrder () {
      Dialog.confirm({
        title: '审核订单',
        className: 'order-dialog',
        message: '确定审核订单？审核订单后将不能改价。'
      }).then(() => {
        this.changeOrderState(1, '审核成功')
      }).catch(() => {
        // on cancel
      })
    },
    /**
     * @description 确认改价
     */
    async confirmEdit () {
      const sellGoods = this.order.goods_list.sell_goods
      const params = []
      Object.keys(sellGoods).map(item => {
        sellGoods[item].map(goods => {
          params.push({
            order_goods_id: goods.order_goods_id,
            goods_id: goods.goods_id,
            bid_price: goods.bid_price
          })
        })
      })
      let { status, info } = await modifyPrice({
        order_cate_number: this.order.order_cate_number,
        order_number: this.order.order_number,
        goods_price_arr: params
      })
      Toast(info.msg)
      if (status === ResultCode.SUCCESS) {
        this.showPopup = false
      }
    },
    confirmCancelOrder () {
      this.changeOrderState(3, '弃单成功')
    },
    async changeOrderState (state, msg) {
      const params = {
        order_cate_number: this.order.order_cate_number,
        order_number: this.order.order_number,
        order_state: state
      }
      if (this.state === 3) {
        params.cancel_order_message = this.cancel_order_message
      }
      let { status, info } = await editOrderState(params)
      if (status === ResultCode.SUCCESS) {
        this.loadData()
        Toast(msg)
      } else {
        Toast(info.msg)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.order-state{
  background: #FFFFFF;
  width: 100%;
  padding: 8px 11px;
  height: 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  .status-word{
    font-size: 14px;
    color: #333333;
  }
}
.order-address{
  background: #FFFFFF;
  border-radius: 0 0 15px 15px;
  padding: 8px 11px;
  min-height: 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
}
.order-top{
    height: 45px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .caption{
      color: #333333;
      font-size: 14px;
    }
  }
.order-list{
  background: #FFFFFF;
  border-radius: 15px;
  .activity-msg{
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    overflow: hidden;
    p{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &-content{
    border-bottom: 1px solid $border-color-base;
    &-item{
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      &-img{
        width: 60px;
        height: 60px;
        box-sizing: border-box;
        border: 1px solid $border-color-base;
        img{
          width: 100%;
          height: 100%;
        }
      }
      &-info{
        width: 283px;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .price-input{
          width: 66px;
          height: 19px;
          border: 1px solid $border-color-base;
          border-radius:2px;
        }
        &-bottom{
          display: flex;
          justify-content: space-between;
          div{
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  &-bottom{
    margin: 0 10px;
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    li{
      display: flex;
      justify-content: space-between;
      height: 23px;
    }
  }
}
.order-info{
  width: 100%;
  min-height: 141px;
  border-radius: 15px;
  background: #FFFFFF;
  margin-top: 10px;
  &-top{
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: #333333;
    font-size: 14px;
    border-bottom: 1px solid $border-color-base;
  }
  &-content{
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 10px 10px;
    li{
      min-height: 23px;
    }
  }
}
.red{
  color: #F53737;
}
.order-operation{
  height: 49px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  span{
    display: inline-block;
    padding: 6px 14px;
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    margin-right: 10px;
  }
  .cancel{
    border-color: #D2D2D2;
    color: #777777;
  }
  .edit-price{
    border-color:var(--APP_theme_color);
    color: var(--APP_theme_color);
  }
  .accept-order{
    background: var(--APP_theme_color);
    color: #FFFFFF;
    border-color: var(--APP_theme_color);
  }
}
.cancel-order-dialog{
  padding: 15px 40px 20px;
  p{
    color: #666666;
    font-size: 15px;
  }
  input{
    width: 238px;
    height: 30px;
    border: 1px solid #EEEEEE;
    margin-top: 15px;
    padding-left: 5px;

  }
}
.font1{
  color: #333333
}
.font2{
  color: #777777;
}
.tag{
  color: #D63103;
  border: 1px solid #D63103;
  width: 35px;
  height: 12px;
  text-align: center;
  margin-left: 5px;
  padding: 2px;
  border-radius: 2px;

}
.van-dialog{
  /deep/{
    .van-dialog__confirm{
      color: var(--APP_theme_color);
    }
    .van-dialog__header{
      font-weight: 600;
      padding-top: 10px;
    }
  }

}
.goods-tag{
  color: #F24571;
  border: 1px solid #F24571;
  border-radius: 3px;
  padding: 1px 2px;
  margin-right: 5px;
}
</style>
<style lang="scss">
.order-dialog{
  .van-dialog__header{
        font-weight: 600;
        padding-top: 10px;
      }
}
</style>
